















































































































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {GetOrderSheetsOrderSheetNoCouponsRequest} from 'supporter';
@Component({
  components: {CompSelectBox}
})
export default class ManualCoupon extends Vue {
  private cartCouponContent: any = [];
  private productContet: any = [];
  private cartSelect: any = {
    value: undefined
  };
  private cartCouponDiscountAmt: any = 0;
  private previousCouponAmt: any = 0;
  private previousCartValue: any = undefined;

  private created(): void {
    this.getCouponInfo();
  }
  private mounted(): void {
    addClass(document.body, 'popup popup_large');
  }

  private beforeDestroy(): void {
    removeClass(document.body, 'popup popup_large');
  }
  private formatterProductList(list: any, selectArr: string): void {
    if (list.length === 0) {
      return;
    }
    list.map((item: any): any => {
      item[selectArr].map((sItem: any): any => {
        if (sItem.selected) {
          item.selectValue = sItem.couponIssueNo;
        }
        if (!sItem.selected && sItem.used) {
          this.$set(sItem, 'disabledV', true);
        }
      });
    });
  }
  private formatterCartSelect(arr: any): void {
    if (arr.length === 0) {
      this.cartSelect.value = undefined;
    } else {
      arr.map((item: any): any => {
        if (item.selected) {
          this.cartSelect.value = item.couponIssueNo;
        }
        if (!item.selected && item.used) {
          this.$set(item, 'disabledV', true);
        }
      });
    }
  }
  private formatterCalculeRequest(content: any): any {
    if (content.length === 0) {
      return;
    }
    let arr: any = [];
    content.map((item: any): any => {
      if (item.selectValue) {
        let obj: any = {couponIssueNo: item.selectValue, productNo: item.productNo};
        arr.push(obj);
      }
    });
    return arr;
  }
  private handleApply(): void {
    if (!window.opener || !this.$route.query.callback) {
      alert(this.$t('ORDER_MANUAL_COUPON_ALERT'));
      return;
    }
    let request: any = {
      pathParams: {
        orderSheetNo: this.$route.params.theOrderSheetNo
      },
      data: {
        productCoupons: [],
        cartCouponIssueNo: 0
      }
    };
    if (this.cartSelect.value === undefined) {
      request.data.cartCouponIssueNo = 0;
    } else {
      request.data.cartCouponIssueNo = this.cartSelect.value;
    }
    request.data.productCoupons = this.formatterCalculeRequest(this.productContet);
    this.$api.postOrderSheetOrderSheetNoCouponsApply(request).then((res: any): any => {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(res.data)});`);
      window.close();
    });
  }
  private handleCouponCalcule(): any {
    let otherCouponUsable: any = true;
    this.cartCouponContent.map((item: any): any => {
      if (item.couponIssueNo === this.cartSelect.value) {
        if (!item.otherCouponUsable) {
          otherCouponUsable = false;
        }
      }
    });
    if (this.cartSelect.value > 0 && !otherCouponUsable && !confirm(this.$t('ORDER_MANUAL_COUPON_CONFIRM') as any)) {
      this.cartCouponDiscountAmt = this.previousCouponAmt;
      this.cartSelect.value = this.previousCartValue;
      return false;
    }
    this.handleCalcule();
  }
  private handleCalcule(): void {
    let request: any = {
      pathParams: {
        orderSheetNo: this.$route.params.theOrderSheetNo
      },
      data: {
        productCoupons: [],
        cartCouponIssueNo: 0
      }
    };
    if (this.cartSelect.value === undefined) {
      request.data.cartCouponIssueNo = 0;
    } else {
      request.data.cartCouponIssueNo = this.cartSelect.value;
    }
    this.previousCartValue = this.cartSelect.value;
    request.data.productCoupons = this.formatterCalculeRequest(this.productContet);
    this.$api.postOrderSheetsOrderSheetNoCouponsCalculate(request).then((res: any): any => {
      this.productContet = [];
      this.productContet = res.data.products;
      this.formatterProductList(this.productContet, 'productCoupons');
      this.cartCouponDiscountAmt = res.data.cartCouponDiscountAmt;
      this.previousCouponAmt = this.cartCouponDiscountAmt;
    });
  }
  private getCouponInfo(): void {
    let request: GetOrderSheetsOrderSheetNoCouponsRequest = {
      pathParams: {
        orderSheetNo: this.$route.params.theOrderSheetNo
      }
    };
    this.$api.getOrderSheetsOrderSheetNoCoupons(request).then((res: any): any => {
      this.cartCouponContent = [];
      this.productContet = [];
      this.cartCouponContent = res.data.cartCoupons;
      this.productContet = res.data.products;
      this.formatterProductList(this.productContet, 'productCoupons');
      this.formatterCartSelect(this.cartCouponContent);
      this.cartCouponDiscountAmt = res.data.cartCouponDiscountAmt;
    });
  }
}
